/*
 * @Author: vinnypeng
 * @Date: 2022-03-22 16:36:14
 * @Last Modified by: vinnypeng
 * @Last Modified time: 2022-05-30 10:10:08
 */

import { List } from '@tencent/tea-component';
import { goLogin } from '@utils/login-util';
import React, { useEffect, useState } from 'react';
import type { FC } from 'react';
import styles from './index.module.scss';
import { useRouter } from 'next/router';
import { ALWAYS_SHOW_MOBILE_HEAD } from 'src/pages/auth-page-config';
import ReportElement from '../ReportElement';
import { accountAction, Action, useAccountInfo } from 'src/hooks/useAccount';
import DefaultAvatar from '@assets/imgs/default-avatar.png';
import NavBanner from '@tencent/tpm-meeting-active/lib/NavBanner';
import '@tencent/tpm-meeting-active/lib/NavBanner/style';
import MobileHeader from 'src/components/Layout/MobileHeader';
import classname from 'classnames';
import { UserData } from '@hooks/useLogin';
import { isMobile } from '@utils/ua/is-mobile';
import useViewPoint from '@hooks/useViewPoint';
import { useDisabledLogoRedirectConfig } from '@hooks/useRainbowConfig';
import { IS_I18N } from 'src/voov';
const LOGO_SVG = 'https://cdn.calendar.tencent.com/calendar_res/activity/email-logo.svg';
// pc端头像组件

const register = () => {
  window.location.href = `${window.location.origin}/regist.html?redirect_link=${encodeURIComponent(
    location.href,
  )}`;
};
export const getMenuList = (
  userData: Partial<UserData>,
  pathname: string,
  canChangeAccount?: boolean,
) => {
  const onMenClick = (opt: Action) => {
    accountAction(userData, pathname)(opt);
  };

  return (
    <div>
      {userData?.userid ? (
        <List type="option">
          <ReportElement
            element={List.Item}
            onClick={() => onMenClick('meeting')}
            code_click="eventplace_public_meeting_null_null_null_click"
          >
            我的会议
          </ReportElement>
          {canChangeAccount && (
            <ReportElement
              element={List.Item}
              code_click="eventplace_public_account_null_null_null_click"
              onClick={() => onMenClick('change-account')}
            >
              切换账号
            </ReportElement>
          )}
          <List.Item onClick={() => onMenClick('logout')}>退出登录</List.Item>
        </List>
      ) : (
        <List type="option">
          {/* @ts-ignore */}
          <List.Item onClick={goLogin}>登录</List.Item>
          <List.Item onClick={register}>免费注册</List.Item>
          <ReportElement
            element={List.Item}
            onClick={goLogin}
            code_click="eventplace_public_meeting_null_null_null_click"
          >
            我的会议
          </ReportElement>
        </List>
      )}
    </div>
  );
};

export const useAccountUI = () => {
  const info = useAccountInfo();
  const [canChangeAccount, setCanChangeAccount] = useState(false);
  const [canEnter, setEnterSpace] = useState(false);
  const router = useRouter();
  const { pathname } = router;

  useEffect(() => {
    if (info?.canChangeAccount !== canChangeAccount && info?.canChangeAccount !== undefined) {
      setCanChangeAccount(info?.canChangeAccount);
    }
    if (info?.enterSpace !== canEnter && info?.enterSpace !== undefined) {
      setEnterSpace(info?.enterSpace);
    }
  }, [info, canEnter, canChangeAccount]);

  const user = {
    imageUrl: info?.avatar || DefaultAvatar,
    name: info?.name,
    reverse: false,
  };

  const goIndexPage = () => {
    if (!info.userid && pathname === '/event/[eventid]/registration') {
      // 直接跳转登录
      goLogin();
      return;
    }
    // voov的情况下, 直接进广场
    if (IS_I18N) {
      if (info.isHost || canEnter) {
        window.location.href = '/events-lobby/square';
        return;
      }
      window.location.href = `${window.location.origin}/user-center`;
      return;
    }
    if (info.isHost) {
      router.push('/home');
    } else if (canEnter) {
      window.location.href = '/events/square';
    } else {
      window.location.href = `${window.location.origin}/user-center`;
    }
  };
  return {
    canChangeAccount,
    user,
    userData: info,
    goIndexPage,
  };
};
interface Param {
  isDisabledLogo?: boolean;
}
const AccountInfo = ({ isDisabledLogo }: Param) => {
  const { canChangeAccount, user, userData, goIndexPage } = useAccountUI();
  const router = useRouter();
  // todo 获取当前用户的hostId;
  return (
    <NavBanner
      responsive
      className={styles.newHeader}
      onLogoClick={() => {
        if (isDisabledLogo) return;
        goIndexPage();
      }}
      userProps={{
        ...user,
        onClick: () => {
          if (!isMobile()) return goIndexPage();
        },
        dropdownProps: {
          button: '',
          children: getMenuList(userData || {}, router.pathname, canChangeAccount),
          trigger: 'hover',
          boxStyle: { boxShadow: 'none' },
        },
        dropdownPlace: 'bottom-end',
      }}
    />
  );
};

const AccountHeader = () => {
  const { isMobileUi } = useViewPoint();
  const router = useRouter();
  const { pathname, query } = router;
  const showMobileHeader = ALWAYS_SHOW_MOBILE_HEAD.includes(pathname);
  const eventId = query?.eventid as string;
  const isDisabledRedirect = useDisabledLogoRedirectConfig(eventId);
  const isDisabledLogo = isDisabledRedirect && pathname.includes('/event/[eventid]/registration');
  if (!isMobileUi && !showMobileHeader) {
    return <AccountInfo isDisabledLogo={isDisabledLogo} />;
  }
  return <MobileHeader isDisabledLogo={isDisabledLogo} />;
};

export default AccountHeader;

export const Logo: FC<{ className?: string }> = ({ className }) => (
  <div className={classname(styles.brand, className)}>
    <img className={styles.logo} src={LOGO_SVG} />
  </div>
);
